export const COUNSELING_REVIEW_PAGE_PROP_MAP = {
    sourcePage: "shikshaCounselingReviewPage",
    eventCategory: "COUNSELING_REVIEW_PAGE",
    mobileTrackingData: {
        requestACallBack: {
            trackingId: {
                register: 2105,
                requestACallBack: 2109,
            },
            widget: "topSection",
            eventAction: "requestACallBack",
        },
        writeACounselorReview: {
            trackingId: 2117,
            widget: "topSection",
            eventAction: "writeACounselorReview",
        },
    },
    desktopTrackingData: {
        requestACallBack: {
            trackingId: {
                register: 2103,
                requestACallBack: 2107,
            },
            widget: "topSection",
            eventAction: "requestACallBack",
        },
        writeACounselorReview: {
            trackingId: 2115,
            widget: "topSection",
            eventAction: "writeACounselorReview",
        },
    },
};
